import { PatchOwnerInitialInfoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchOwnerInitialInfo/patchOwnerInitialInfoQuery.type';
import { patchOwnerInitialVisitInfo } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchOwnerInitialVisitInfo/patchOwnerInitialVisitInfoQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchOwnerInitialVisitInfoQueryOptions = () =>
  useMutation({
    mutationKey: ['PatchOwnerInitialInfoQuery'],
    mutationFn: (params: PatchOwnerInitialInfoQueryParamsType) =>
      patchOwnerInitialVisitInfo(params),
  });
